import { useQuery } from "@tanstack/react-query";
import useApiMedal from "./useApiMedal"

const useListMedal = () => {
    const { listMedals } = useApiMedal();

    return useQuery({
        queryKey: ["medals"],
        queryFn: () => listMedals(),
        staleTime: 1000 * 60 * 60 * 24,
        placeholderData: (previousData) => previousData,
    })
}

export default useListMedal;